import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * Unificação de cadastros duplicados — migração de MenuAcademico/UnificarAlunos.aspx e
 * UnificarPessoal.aspx. UMA view, duas rotas: o tipo vai em `meta.tipo` porque o menu do legado
 * abre a tela nova pelo NOME da rota (a query string não atravessa o proxy).
 *
 * Permissões PRÓPRIAS (2200101601 e 2200101701), vizinhas das legadas (2200101600 e 2200101700)
 * e nunca elas: a rede libera a tela nova sem mexer em quem usa a antiga. Ver
 * docs/unificacao-cadastros/README.md.
 */
export default [
  {
    description: 'Unificar Estudantes Duplicados',
    path: '/administracao/unificacao/estudantes',
    name: 'unificacao_estudantes',
    component: () => import('@/views/administracao/unificacaocadastro/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.UNIFICARESTUDANTESDUPLICADOSNOVO_MENU_2200101601],
      tipo: 'Estudantes',
    },
    goesToMenu: true,
  },
  {
    description: 'Unificar Funcionários Duplicados',
    path: '/administracao/unificacao/funcionarios',
    name: 'unificacao_funcionarios',
    component: () => import('@/views/administracao/unificacaocadastro/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.UNIFICARFUNCIONARIOSDUPLICADOSNOVO_MENU_2200101701],
      tipo: 'Servidores',
    },
    goesToMenu: true,
  },
];
